export const USER_LOGIN_REQUEST="USER_LOGIN_REQUEST"
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAIL="USER_LOGIN_FAIL"

export const USER_REGISTER_REQUEST="USER_REGISTER_REQUEST"
export const USER_REGISTER_SUCCESS="USER_REGISTER_SUCCESS"
export const USER_REGISTER_FAIL="USER_REGISTER_FAIL"

export const LOAD_USER_REQUEST="LOAD_USER_REQUEST"
export const LOAD_USER_SUCCESS="LOAD_USER_SUCCESS"
export const LOAD_USER_FAIL="LOAD_USER_FAIL"

export const USER_LOGOUT_SUCCESS="USER_LOGOUT_SUCCESS"
export const USER_LOGOUT_FAIL="USER_LOGOUT_FAIL"

export const UPDATE_PROFILE_REQUEST=" UPDATE_PROFILE_REQUEST"
export const UPDATE_PROFILE_SUCCESS=" UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_RESET=" UPDATE_PROFILE_RESET"
export const UPDATE_PROFILE_FAIL="    UPDATE_PROFILE_FAIL"

export const UPDATE_PASSWORD_REQUEST="UPDATE_PASSWORD_REQUEST"
export const UPDATE_PASSWORD_SUCCESS="UPDATE_PASSWORD_SUCCESS"
export const UPDATE_PASSWORD_RESET="UPDATE_PASSWORD_RESET"
export const UPDATE_PASSWORD_FAIL="UPDATE_PASSWORD_FAIL"

export const FORGOT_PASSWORD_REQUEST="FORGOT_PASSWORD_REQUEST"
export const FORGOT_PASSWORD_SUCCESS="FORGOT_PASSWORD_SUCCESS"
export const FORGOT_PASSWORD_FAIL="FORGOT_PASSWORD_FAIL"


export const RESET_PASSWORD_REQUEST="RESET_PASSWORD_REQUEST"
export const RESET_PASSWORD_SUCCESS="RESET_PASSWORD_SUCCESS"
export const RESET_PASSWORD_FAIL="RESET_PASSWORD_FAIL"

// Admin constants
export const ALL_USERS_REQUEST="ALL_USERS_REQUEST"
export const ALL_USERS_SUCCESS="ALL_USERS_SUCCESS"
export const ALL_USERS_FAIL="ALL_USERS_FAIL"

export const USER_DETAILS_REQUEST="USER_DETAILS_REQUEST"
export const USER_DETAILS_SUCCESS="USER_DETAILS_SUCCESS"
export const USER_DETAILS_FAIL="USER_DETAILS_FAIL"

export const UPDATE_USER_REQUEST="UPDATE_USER_REQUEST"
export const UPDATE_USER_SUCCESS="UPDATE_USER_SUCCESS"
export const UPDATE_USER_RESET="UPDATE_USER_RESET"
export const UPDATE_USER_FAIL="UPDATE_USER_FAIL"

export const DELETE_USER_REQUEST="DELETE_USER_REQUEST"
export const DELETE_USER_SUCCESS="DELETE_USER_SUCCESS"
export const DELETE_USER_RESET="DELETE_USER_RESET"
export const DELETE_USER_FAIL="DELETE_USER_FAIL"

export const SUBMIT_FEEDBACK_REQUEST="SUBMIT_FEEDBACK_REQUEST"
export const SUBMIT_FEEDBACK_SUCCESS="SUBMIT_FEEDBACK_SUCCESS"
export const SUBMIT_FEEDBACK_RESET="SUBMIT_FEEDBACK_RESET"
export const SUBMIT_FEEDBACK_FAIL="SUBMIT_FEEDBACK_FAIL"

export const ALL_FEEDBACKS_REQUEST="ALL_FEEDBACKS_REQUEST"
export const ALL_FEEDBACKS_SUCCESS="ALL_FEEDBACKS_SUCCESS"
export const ALL_FEEDBACKS_FAIL="ALL_FEEDBACKS_FAIL"

export const FEEDBACK_DELETE_REQUEST="FEEDBACK_DELETE_REQUEST"
export const FEEDBACK_DELETE_SUCCESS="FEEDBACK_DELETE_SUCCESS"
export const FEEDBACK_DELETE_RESET="FEEDBACK_DELETE_RESET"
export const FEEDBACK_DELETE_FAIL="FEEDBACK_DELETE_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS";